export const normalizeList = (values = []) =>
  [
    ...new Set(
      (values || []).map((value) => String(value || "").trim()).filter(Boolean),
    ),
  ].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }));

export const getSortLabel = (value, options) =>
  options.find((option) => option.value === value)?.label || "Newest";

export const findPresetRange = (minPrice, maxPrice, ranges) => {
  const min = minPrice === "" || minPrice == null ? null : Number(minPrice);
  const max = maxPrice === "" || maxPrice == null ? null : Number(maxPrice);

  if (
    (min !== null && !Number.isFinite(min)) ||
    (max !== null && !Number.isFinite(max))
  ) {
    return null;
  }

  return (
    ranges.find((range) => {
      const rangeMin = Number(range.min);
      const sameMin = min === rangeMin;
      const sameMax =
        range.max == null ? max === null : max === Number(range.max);
      return sameMin && sameMax;
    }) || null
  );
};

export const luxurySelectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 52,
    borderRadius: 999,
    borderColor: state.isFocused ? "rgba(176, 141, 42, 0.55)" : "var(--border)",
    backgroundColor: "rgba(255,255,255,0.92)",
    boxShadow: state.isFocused ? "var(--focus-ring)" : "none",
    paddingInline: 6,
    "&:hover": {
      borderColor: "var(--border-strong)",
    },
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "0 8px",
  }),
  placeholder: (base) => ({
    ...base,
    color: "var(--text-muted)",
  }),
  singleValue: (base) => ({
    ...base,
    color: "var(--text)",
    fontWeight: 600,
  }),
  menu: (base) => ({
    ...base,
    border: "1px solid var(--border)",
    borderRadius: 18,
    boxShadow: "var(--shadow-md)",
    overflow: "hidden",
    zIndex: 50,
  }),
  menuList: (base) => ({
    ...base,
    padding: 8,
  }),
  option: (base, state) => ({
    ...base,
    borderRadius: 12,
    backgroundColor: state.isSelected
      ? "rgba(18, 18, 18, 0.08)"
      : state.isFocused
        ? "var(--surface-2)"
        : "#fff",
    color: "var(--text)",
    fontWeight: state.isSelected ? 700 : 500,
    cursor: "pointer",
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: "var(--text-muted)",
  }),
};
